import { configureStore, PayloadAction } from '@reduxjs/toolkit';
import { createEpicMiddleware } from 'redux-observable';

import {
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import rootReducer from './rootReducer';
import rootEpic from './epics';

/**
 * We need the PayloadAction's payload type to be "any" so that our epicMiddleware can
 * catch any incoming actions. Each individual epic will make sure to process only its
 * required actions.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const epicMiddleware = createEpicMiddleware<PayloadAction<any>>();

/**
 * Additional middlewares should be defined in this array. Note that
 * the call to getDefaultMiddleware should be invoked last, otherwise the dispatch
 * will not be typed correctly.
 * Not sure why this is happening, but it is an issue when defining additional
 * middlewares.
 */

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(epicMiddleware),
  devTools: process.env.NODE_ENV !== 'production',
  enhancers: [],
});

epicMiddleware.run(rootEpic);

export default store;
export type AppDispatch = typeof store.dispatch;
export const persistor = persistStore(store);
